export default "__VITE_ASSET__B1_UKcMj__"